import classNames from 'classnames';
import { SearchFieldWithDebounce, SmartFormIcons } from 'components';
import styles from './styles.module.scss';

export const PageSearchWrapper = (props) => {
  const { isSearchActive, resetAction, sendAction, otherSearchParams = {}, onCloseSearch } = props;

  if (!isSearchActive) return <></>;

  return (
    <div className={styles.pageSearchWrapper}>
      <div className={styles.searchWrapper}>
        <SearchFieldWithDebounce
          className={styles.inputWrap}
          classNameInput={styles.searchInput}
          iconClassName={styles.icon}
          resetAction={resetAction}
          sendAction={sendAction}
          isLoading={false}
          placeholder="Search"
          testid="search"
          isTransactionAggregate={true}
          isExpandedVersion
          otherSearchParams={otherSearchParams}
        />

        <div onClick={onCloseSearch} className={classNames(styles.crossCircleIcon)}>
          <SmartFormIcons variant="cancel" />
        </div>
      </div>
    </div>
  );
};
